import getLocalStorageKey from 'api/browser/localstorage/get';
import { LOCALSTORAGE } from 'constants/localStorage';
import { useState } from 'react';
import { useLogAccess } from 'pages/ScopedLogs/useLogAccess';

export function useSavedViewEnabled(): boolean {
	const { restricted, mode } = useLogAccess();
	const [isEnabled] = useState(
		() => getLocalStorageKey(LOCALSTORAGE.SAVED_VIEW_ENABLED) === 'true',
	);

	return (isEnabled && !restricted) || mode === 'namespace';
}
